export default __webpack_public_path__ + "static/media/6d11cb7980e6bdb28bbf2dd0be788e6f.jpg";